import { Attribute, Directive, Input, OnInit, Optional } from '@angular/core';
import { CwcInputDate } from '@cmx-web-components/angular';
import { DestroyedService } from 'app/shared/destroyed/destroyed.service';
import { combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CxUiComponentService } from '../cx-component.service';
import { CxUiConfigService } from '../cx-ui.config.service';
import { CxUiDesignVersion, CxUiRTL } from './cx-design-version.config';

@Directive({
  /* tslint:disable */
  selector:
    'cwc-button, cwc-checkbox, cwc-alert, cwc-color-tag, cwc-modal, cwc-icon, cwc-input-date, cwc-input-time, cwc-card, cwc-switch, cwc-loader, cwc-tooltip, cwc-segmented-controls, cwc-picker, cwc-action-bar-button, cwc-popover, cwc-status-indicator, cwc-side-panel',
  providers: [DestroyedService, CxUiComponentService],
})
export class CxDesignVersionProviderDirective implements OnInit {
  constructor(
    private cxUiComponent: CxUiComponentService<CwcInputDate>,
    private cxUiConfig: CxUiConfigService,

    private destroyed: DestroyedService,

    @Optional() @Attribute('design-version') private designVersionAttribute?: CxUiDesignVersion,
    @Optional() @Attribute('rtl') private rtlAttribute?: CxUiDesignVersion,
  ) {
    this.cxUiComponent.hasSomeAttributeOf([designVersionAttribute, rtlAttribute]);
  }

  @Input()
  public designVersion?: CxUiDesignVersion;

  @Input()
  public rtl?: CxUiRTL;

  public ngOnInit() {
    combineLatest([this.cxUiConfig.selectValueOf('designVersion'), this.cxUiConfig.selectValueOf('rtl')])
      .pipe(takeUntil(this.destroyed))
      .subscribe(([designVersion, rtl]) => {
        if (this.designVersion === undefined) {
          this.cxUiComponent.setProperty('designVersion', this.designVersionAttribute || designVersion);
        }
        if (this.rtl === undefined) {
          this.cxUiComponent.setProperty('rtl', this.rtlAttribute || rtl);
        }
      });
  }
}
